var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col h-full w-full lg:flex-row lg:overflow-hidden"},[_c('background',{staticClass:"w-full h-1/5 lg:h-full lg:w-6/12"}),_c('control',{staticClass:"flex w-full lg:w-6/12"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }